import dynamic from 'next/dynamic';

const Header = dynamic(() =>
  import(/* webpackChunkName: "dwWebHeader" */ '../../../components/Header')
);

const SalesforceLead = dynamic(() =>
  import(/* webpackChunkName: "boatWebSalesforceLead" */ '../../../components/SalesforceLead')
);

const NewsletterSignup = dynamic(() =>
  import(/* webpackChunkName: "boatWebNewsletterSignup" */ '../../../components/NewsletterSignup')
);

const pageBuilderComponent = {
  dw_header: Header,
  'salesforce-lead': SalesforceLead,
  'newsletter-signup': NewsletterSignup
};

export default pageBuilderComponent;
